/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForDeviceLastConnectionElementResponse
 */
export interface ReportForDeviceLastConnectionElementResponse {
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceLastConnectionElementResponse
     */
    targetVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceLastConnectionElementResponse
     */
    deviceVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceLastConnectionElementResponse
     */
    upgradeOrderMessage: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeviceLastConnectionElementResponse
     */
    retryCounter: number | null;
}

export function ReportForDeviceLastConnectionElementResponseFromJSON(json: any): ReportForDeviceLastConnectionElementResponse {
    return ReportForDeviceLastConnectionElementResponseFromJSONTyped(json, false);
}

export function ReportForDeviceLastConnectionElementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceLastConnectionElementResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetVersion': json['targetVersion'],
        'deviceVersion': json['deviceVersion'],
        'upgradeOrderMessage': json['upgradeOrderMessage'],
        'retryCounter': json['retryCounter'],
    };
}

export function ReportForDeviceLastConnectionElementResponseToJSON(value?: ReportForDeviceLastConnectionElementResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'targetVersion': value.targetVersion,
        'deviceVersion': value.deviceVersion,
        'upgradeOrderMessage': value.upgradeOrderMessage,
        'retryCounter': value.retryCounter,
    };
}

